import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { PrimeReactProvider } from "primereact/api";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <PrimeReactProvider value={{ripple : true}}>
                <App />
            </PrimeReactProvider>
        </BrowserRouter>
    </React.StrictMode>
);